import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import React from 'react';

const formatDatapointValue = (
	value: (number | null | undefined) | (string | null | undefined) | (boolean | null | undefined)
): any => {
	if (value === undefined) {
		return '--';
	}

	const type = typeof value;

	switch (type) {
		case 'number':
		case 'string':
			return value;

		default:
			return value ? (
				<Trans i18nKey={`rafi.values.boolean.true`}>true</Trans>
			) : (
				<Trans i18nKey={`rafi.values.boolean.false`}>false</Trans>
			);
	}
};

export {formatDatapointValue};
